// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/fr-BE';

import popularKeyword from './popularKeyword';

// Tenant-specific styles
import '../../../scss/popularKeywordPage/popularKeyword.twh.frbe.scss';

popularKeyword(i18n);
